import React from 'react';
import './barloading.css';
const Logo = `${import.meta.env.BASE_URL}assets/images/sebusca-logo.png`;

function BarLoading() {
  return (
    <div className="bar-loading">
      <div className="bar-loading-inner">
        <img src={Logo} alt="SeBusca" className="bar-loading-logo" />
        <div className="bar-loading-shimmer" />
      </div>
    </div>
  );
}

export default BarLoading;
